import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_LOAD_CUSTOM_CSS_CDNS_BEGIN,
  APP_SETTING_LOAD_CUSTOM_CSS_CDNS_SUCCESS,
  APP_SETTING_LOAD_CUSTOM_CSS_CDNS_FAILURE,
  APP_SETTING_LOAD_CUSTOM_CSS_CDNS_DISMISS_ERROR,
} from './constants';

export function loadCustomCssCdns(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_CUSTOM_CSS_CDNS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-css-cdn`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_CUSTOM_CSS_CDNS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_CUSTOM_CSS_CDNS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomCssCdnsError() {
  return {
    type: APP_SETTING_LOAD_CUSTOM_CSS_CDNS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_CUSTOM_CSS_CDNS_BEGIN:
      return {
        ...state,
        loadCustomCssCdnsPending: true,
        loadCustomCssCdnsError: null,
      };

    case APP_SETTING_LOAD_CUSTOM_CSS_CDNS_SUCCESS:
      return {
        ...state,
        loadCustomCssCdnsPending: false,
        loadCustomCssCdnsError: null,
        projectDetail: {
          ...state.projectDetail,
          customCssCdns: action.data,
        },
      };

    case APP_SETTING_LOAD_CUSTOM_CSS_CDNS_FAILURE:
      return {
        ...state,
        loadCustomCssCdnsPending: false,
        loadCustomCssCdnsError: action.data.error,
      };

    case APP_SETTING_LOAD_CUSTOM_CSS_CDNS_DISMISS_ERROR:
      return {
        ...state,
        loadCustomCssCdnsError: null,
      };

    default:
      return state;
  }
}
